import { render, staticRenderFns } from "./v-form.vue?vue&type=template&id=20ca4221&"
import script from "./v-form.vue?vue&type=script&lang=js&"
export * from "./v-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports